import React from "react"
import { isAtrasado } from "../../core/utils"

export default props => {
    const recibos = props.recibos
    return (
        <>
            <div className="title-section">{props.title}</div>
            <table className="table is-bordered" style={{ marginTop: 5 }}>
                <thead>
                    <tr>
                        <th>##</th>
                        <th>Valor</th>
                        <th>Vencimento</th>
                        <th style={{ width: 80, textAlign: "center" }}>Boleto</th>
                    </tr>
                </thead>
                <tbody>
                    {!!recibos && recibos.map(recibo => {
                        let clsStatus = isAtrasado(recibo.date) ? "is-danger" : "is-primary"
                        return (
                            <tr key={recibo.numero.toString()}>
                                <td>{recibo.numero}</td>
                                <td>{recibo.valor}</td>
                                <td>{recibo.vencimento_original}</td>
                                <td style={{ textAlign: "center" }}>
                                    {recibo.status === "Recebido" ? (
                                        <span className="has-text-primary">PAGO</span>
                                    ) : (
                                        <a
                                            rel="noopener noreferrer"
                                            href={recibo.link}
                                            target="_blank"
                                            className={`button is-small ${clsStatus}`}
                                        >
                                            Ver boleto
                                        </a>
                                    )}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </>
    )
}
